module.exports = __webpack_public_path__ + "img/bishop-college-logo.e8891442.jpg";